import React, { useState, useEffect, useContext } from "react";
import "./LoginPage.css";
import { Formik } from 'formik';
import axios from 'axios';
import { site_url } from "../config.js";
import { AuthContext } from '../AuthContext';
import { Navigate, useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import Swal from 'sweetalert2';

function Index() {
  const [msg, setMsg] = useState([]);
  const { user, setUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ref = searchParams.get('ref');
  const { fulluser, setfullUser } = useContext(AuthContext);
  const location = useLocation();
  const [otpSent, setOtpSent] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);

  const showOtpToast = (message) => {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: message || 'OTP sent successfully',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
  };

  // 60s countdown for Resend OTP
  useEffect(() => {
    if (resendCooldown <= 0) return;
    const timer = setInterval(() => setResendCooldown((s) => (s <= 1 ? 0 : s - 1)), 1000);
    return () => clearInterval(timer);
  }, [resendCooldown]);

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [location]);

  const showModal = (modalId) => {
    if (window.bootstrap) {
      const modalElement = document.getElementById(modalId);
      if (modalElement) {
        const modal = new window.bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  };

  const handleResendOtp = async (phone) => {
    if (resendCooldown > 0) return;
    try {
      const response = await axios.post(site_url + '/send_login_otp', { phone });
      setMsg(response.data);
      if (response.data.status === 'success') {
        // setResendCooldown(60);
        showOtpToast(response.data.message);
      } else {
        showModal('actionSheetAlertError');
      }
    } catch (error) {
      console.error(error);
      setMsg({ status: 'failed', message: 'Error sending OTP' });
      showModal('actionSheetAlertError');
    }
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {

    if (!otpSent) {
      // Step 1: Send OTP — toast only
      try {
        const response = await axios.post(site_url + '/send_login_otp', { phone: values.phone });
        setMsg(response.data);
        if (response.data.status === 'success') {
          setOtpSent(true);
          setResendCooldown(60);
          showOtpToast(response.data.message);
        } else {
          showModal('actionSheetAlertError');
        }
      } catch (error) {
        console.error(error);
        setMsg({ status: 'failed', message: 'Error sending OTP' });
        showModal('actionSheetAlertError');
      } finally {
        setSubmitting(false);
      }
    } else {
      // Step 2: Login with OTP
      const data = {
        phone: values.phone,
        otp: values.otp,
      }
      try {
        const response = await axios.post(site_url + '/login_account', data);
        setMsg(response.data);
        if (response.data.status === 'success') {

          console.log(response.data);
          localStorage.setItem('access_token', JSON.stringify(response.data.token));

          if (response.data.device_token) {
            localStorage.setItem('device_token', response.data.device_token);
          }

          setUser(JSON.stringify(response.data.token));

          showOtpToast(response.data.message || 'Login successful');

          setTimeout(() => {
            axios.get(site_url + "/authcustomer_details", {
              headers: {
                Authorization: `Bearer ${response.data.token}`,
                Accept: 'application/json'
              }
            })
              .then(res => {
                setfullUser(res.data.data);

                if (res.data.data.mpin != null) {
                  localStorage.setItem("mpin", res.data.data.mpin);
                }
                // Skip MPIN page and go directly to home
                sessionStorage.setItem("mpin_verified", "true");
                navigate('/UserActivity');
              })
              .catch(err => {
                console.error("API Error:", err.response.data);
              });
          }, 1500);


          resetForm();

        } else if (response.data.status === 'failed') {
          showModal('actionSheetAlertError');
        }
      } catch (error) {
        console.error(error);
        setMsg({ status: 'failed', message: 'Login failed' });
        showModal('actionSheetAlertError');
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-header">
        <img
          src="digital-marketing.jpg"
          alt="Truck"
          className="header-image"
        />
      </div>
      <div className="login-form">
        <Formik
          initialValues={{ phone: location.state?.phone || '', otp: '' }}
          enableReinitialize={true}
          validate={values => {
            const errors = {};
            if (!values.phone) {
              errors.phone = 'Phone Number is required';
            } else if (!/^\d{10}$/.test(values.phone)) {
              errors.phone = 'Phone number must be exactly 10 digits';
            }

            if (otpSent && !values.otp) {
              errors.otp = 'OTP is required';
            }

            return errors;
          }}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <h2>{otpSent ? 'Enter OTP' : 'Login Account'}</h2>

              <div className="form-group">
                <label htmlFor="phone">
                  <i className="fa fa-phone"></i>
                </label>
                <input
                  type="number"
                  id="phone"
                  placeholder="Enter Your Mobile Number"
                  name="phone"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.phone}
                  disabled={otpSent}
                />
              </div>
              {errors.phone && touched.phone && (<span className="error">{errors.phone}</span>)}

              {otpSent && (
                <>
                  <div className="form-group">
                    <label htmlFor="otp">
                      <i className="fa fa-key"></i>
                    </label>
                    <input
                      type="number"
                      id="otp"
                      placeholder="Enter 4-digit OTP"
                      name="otp"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.otp}
                    />
                  </div>
                  {errors.otp && touched.otp && (<span className="error">{errors.otp}</span>)}
                </>
              )}

              <button type="submit" disabled={isSubmitting} className="login-button">
                {isSubmitting ? 'Submitting...' : (otpSent ? 'Login' : 'Get OTP')}
              </button>

              {!otpSent && (
                <>
                  <br></br>
                  <div style={{ marginTop: '5%' }}></div>
                  <Link style={{ marginTop: '5%' }} className='mt-2' to={`/Signup`}>Create new account</Link>
                </>
              )}
              {otpSent && (
                <div className="mt-3 text-center">
                  <button
                    type="button"
                    className="btn btn-link"
                    disabled={resendCooldown > 0}
                    onClick={() => handleResendOtp(values.phone)}
                  >
                    {resendCooldown > 0 ? `Resend OTP (${resendCooldown}s)` : 'Resend OTP'}
                  </button>
                </div>
              )}
            </form>
          )}
        </Formik>
      </div>

      {/* Action Sheet Alert - Success */}
      <div className="modal fade action-sheet" id="actionSheetAlertSuccess" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <div className="action-sheet-content">
                <div className="icon-box text-success">
                  <ion-icon name="checkmark-circle"></ion-icon>
                </div>
                <div className="text-center">
                  <h3>Success</h3>
                  <p>{msg.message}</p>
                </div>
                <a href="#" className="btn btn-primary btn-block btn-lg" data-bs-dismiss="modal">OK</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Action Sheet Alert - Error */}
      <div className="modal fade action-sheet" id="actionSheetAlertError" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <div className="action-sheet-content">
                <div className="icon-box text-danger">
                  <ion-icon name="close-circle"></ion-icon>
                </div>
                <div className="text-center">
                  <h3>Error</h3>
                  <p>{msg.message}</p>
                </div>
                <a href="#" className="btn btn-primary btn-block btn-lg" data-bs-dismiss="modal">OK</a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Index;
